import QuickSearchItem from "@/modules/partner/models/QuickSearchItem";

export default interface BisnodePartner {
    quickSearchItems: QuickSearchItem[];
}

export const bisnodePartnerDefaultProps: BisnodePartner = {
    quickSearchItems: [],
}